import { InjectionToken } from '@angular/core';

export type ProductsDataConfig = {
  apiPrefix: string;
};

export const PRODUCTS_DATA_CONFIG = new InjectionToken<ProductsDataConfig>(
  'products-data-config',
);
